import * as React from "react";
import type { SVGProps } from "react";
const SvgNotificationBubble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13.326 2.461q-.597-.06-1.214-.061C6.748 2.4 2.4 5.94 2.4 10.306s4.348 7.906 9.712 7.906c.838 0 1.652-.087 2.428-.25l3.642 3.638v-5.082C19.817 15.412 21.13 13.75 21.6 12m0-5.4a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default SvgNotificationBubble;
